import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';

export const selectFMFState = createSelector(fromFeature.getFMFState, (state) => state);
